/**
 * Why the backend ended this session. JwtAuthenticationFilter answers 401 with a
 * `code` when a signature-valid token belongs to an account that can no longer
 * hold a session; the sign-out notice should say which, instead of "expired".
 */
const SESSION_END_MESSAGES = {
  ACCOUNT_DISABLED: 'Your account has been disabled by an administrator. You have been signed out.',
  SESSION_REVOKED: 'You were signed out because your password changed or all sessions were ended. Please sign in again.',
  ACCOUNT_NOT_FOUND: 'This account no longer exists. You have been signed out.',
};

export const isSessionEndCode = (errorData) =>
  Boolean(errorData && Object.prototype.hasOwnProperty.call(SESSION_END_MESSAGES, errorData.code));

export const sessionEndMessage = (errorData, fallback) =>
  (isSessionEndCode(errorData) ? SESSION_END_MESSAGES[errorData.code] : fallback);
